import LAmap0 from './src/main'

/* istanbul ignore next */
LAmap0.install = function(Vue) {
  Vue.component(LAmap0.name, LAmap0)
}

export default LAmap0
